import { c as _c } from "react/compiler-runtime";
import React from 'react';
const IconArrowLeftWhite = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M3.629 13.206L13.87 2.376a1.184 1.184 0 0 0-.01-1.639 1.088 1.088 0 0 0-1.572.01L.384 13.337l11.902 10.788a1.092 1.092 0 0 0 1.573-.11 1.188 1.188 0 0 0-.115-1.64L3.629 13.206z" fill="#FFF" fillRule="nonzero" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={15} height={25} viewBox="0 0 15 25" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default IconArrowLeftWhite;